<template>
  <div>
    <div class="h1">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd122/btn.png"
          alt=""
        />
      </div>
    </div>
    <div class="h2">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd122/btn.png"
          alt=""
        />
      </div>
    </div>
    <div class="h3">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd122/btn.png"
          alt=""
        />
      </div>
    </div>
    <div class="h4">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd122/btn.png"
          alt=""
        />
      </div>
    </div>
    <div class="h5">
      <div class="w"></div>
    </div>
    <div class="h6">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd122/btn.png"
          alt=""
        />
      </div>
    </div>

    <div class="bottomss">
      <div class="boxx"></div>
      <p>————&nbsp;投资有风险入市需谨慎&nbsp;————</p>
      <p>
        从事证券投资或期货交易，请通过合法证券期货经营机构进行&nbsp;&nbsp;&nbsp;合法机构名单可到中国证监会网站
        (<a href="http://www.csrc.gov.cn/">www.csrc.gov.cn</a>)查询
      </p>
      <p>
        北京天相财富管理顾问有限公司 &nbsp;&nbsp;&nbsp;
        <a href="https://beian.miit.gov.cn/">京ICP备16068579号-1</a
        >&nbsp;&nbsp;&nbsp; 执证编号：91110102MA001GJE1N
      </p>
      <p>天相股多多软件版本号：v1.3.1.1288 更新时间：2022年2月</p>
      <p style="text-decoration: underline; cursor: pointer" class="qwer">
        <!-- 联系电话:010-********&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
        <span @click="open_yinsi()" style="margin-right: 10px"
          >隐私保护政策</span
        >
        <span @click="open_fuwuxieyi()">软件服务协议</span>
      </p>
      <p>开发者名称:北京天相财富管理顾问有限公司</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      res: false
    };
  },
  mounted() {
    this.clientIp();
  },
  methods: {
    open_yinsi() {
      window.open("https://cdn.juniubang.com/apk/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://cdn.juniubang.com/apk/许可使用协议4.7.pdf");
    },

    to_xaizai() {
      this.post_leilei_data();
      // window.open("https://cdn.juniubang.com/apk/GDD1002.exe");
    },
    // 给磊磊传页面数据
    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          qhclickid: this.$route.query.sourceid,
          url: window.location.href,
          code: this.$route.query.code,
          type: "360"
        })
        .then(res => {  window.open(res.data.message);});
    },

    clientIp() {
      this.$http.post("/client_ip", { url: window.location.href }).then(res => {
        window.localStorage.setItem("_number", res.data);
      });
    }
  }
};
</script>
<style lang="less" scoped>
img {
  display: block;
}
.h1 {
  width: 100%;
  height: 764px;
  background: url(../../assets/img/pagess/gdd122/banner.jpg) no-repeat center;
  .w {
    width: 100px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      left: 180px;
      top: 390px;
    }
  }
}
.h2 {
  width: 100%;
  height: 768px;
  .w {
    width: 1200px;
    height: 768px;
    background: url(../../assets/img/pagess/gdd122/h2.jpg) no-repeat center;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: 410px;
      left: 80px;
    }
  }
}
.h3 {
  width: 100%;
  height: 768px;
  .w {
    width: 1200px;
    height: 768px;
    background: url(../../assets/img/pagess/gdd122/h3.jpg) no-repeat center;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: 430px;
      right: 80px;
    }
  }
}
.h4 {
  width: 100%;
  height: 768px;
  .w {
    width: 1200px;
    height: 768px;
    background: url(../../assets/img/pagess/gdd122/h4.jpg) no-repeat center;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: 475px;
      left: 80px;
    }
  }
}
.h5 {
  width: 100%;
  height: 768px;
  .w {
    width: 1200px;
    height: 768px;
    background: url(../../assets/img/pagess/gdd122/h5.jpg) no-repeat center;
    margin: 0 auto;
  }
}
.h6 {
  width: 100%;
  height: 768px;
  .w {
    width: 1200px;
    height: 768px;
    background: url(../../assets/img/pagess/gdd122/h6.png) no-repeat center;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: 280px;
      left: 190px;
    }
  }
}
.bottomss {
  width: 100%;
  height: 230px;
  background-color: #a15414;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  .boxx {
    width: 100%;
    height: 30px;
  }
  .qwer span:hover {
    color: rgb(0, 0, 0);
  }
  a {
    font-size: 12px;
    color: #fff;
  }
  p {
    margin: 8px 0;
    font-size: 12px;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pagess/gdd125.vue